// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"seal"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.5 7C16.5 8.43197 15.8311 10.0397 14.7888 11.1453C14.3392 11.6221 14 12.2208 14 12.8762V13C14 13.2761 14.2239 13.5 14.5 13.5H20C20.5523 13.5 21 13.9477 21 14.5V18.5H3V14.5C3 13.9477 3.44772 13.5 4 13.5H9.5C9.77614 13.5 10 13.2761 10 13V12.8762C10 12.2208 9.6608 11.6221 9.2112 11.1453C8.16886 10.0397 7.5 8.43197 7.5 7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 7C16.5 8.43197 15.8311 10.0397 14.7888 11.1453C14.3392 11.6221 14 12.2208 14 12.8762V13C14 13.2761 14.2239 13.5 14.5 13.5H20C20.5523 13.5 21 13.9477 21 14.5V18.5H3V14.5C3 13.9477 3.44772 13.5 4 13.5H9.5C9.77614 13.5 10 13.2761 10 13V12.8762C10 12.2208 9.6608 11.6221 9.2112 11.1453C8.16886 10.0397 7.5 8.43197 7.5 7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 21.5H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SealIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'seal',
    ref,
    icon: element,
  },
));

SealIcon.displayName = 'SealIcon';

export default SealIcon;
